import React, { useEffect, useRef } from "react";
import Header from "./../Header/Header";
import Footer from "../Footer/Footer";
const Intro = () => {
  const applyAnimation = (animateRef) => {
    animateRef.current.style.opacity = "1";
    animateRef.current.style.animationDuration = "1s";
    animateRef.current.classList.add("animate__animated");
  };

  const animateRef1 = useRef();
  const animateRef2 = useRef();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust this value based on when you want the animation to trigger
    };
    const handleIntersectionSlideInLeft = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInLeft");
          observer.unobserve(entry.target);
        }
      });
    };
    const handleIntersectionSlideInRight = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInRight");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer1 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInRight(entries, observer, animateRef1),
      options
    );
    if (animateRef1.current) {
      animateRef1.current.style.opacity = "0";
      observer1.observe(animateRef1.current);
    }
    const observer2 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef2),
      options
    );
    if (animateRef2.current) {
      animateRef2.current.style.opacity = "0";
      observer2.observe(animateRef2.current);
    }
    return () => {
      observer1.disconnect();
      observer2.disconnect();
    };
  }, []);

  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="intro_wrap">
        <div className="intro_banner_box">
          <div
            className="intro_banner animate__animated"
            ref={animateRef1}
          ></div>
          <div
            className="intro_text_box top animate__animated animate__slideInLeft"
            style={{ animationDuration: "1.1s" }}
          >
            <div className="intro_sub_title">키움성장소개</div>
            <div className="intro_title_box">
              <div className="intro_title">키움성장의원 소아청소년과</div>
              <div className="intro_name">
                <p className="name_light">허경</p>
                원장
              </div>
            </div>
          </div>
          <div
            className="intro_text_box bottom animate__animated animate__fadeIn"
            style={{ animationDuration: "2s" }}
          >
            <div className="intro_career_box ">
              <div className="career_text_box left">
                <div className="career_title">약력</div>
                <div className="career_text">
                  의학박사
                  <br /> 소아내분비세부전문의
                  <br /> 인제대학교백병원, 고려대학교병원 외래교수
                  <br /> 임상강사 UCLA소아내분비연수 소아청소년과의사회 학술이사
                  <br /> 소아초음파연구회 회장
                  <br />
                  소아내분비학회 정회원
                  <br /> 식약처 중앙약사심의위원회 위원
                </div>
              </div>
              <div className="career_text_box right">
                <div className="career_title">강의 및 방송</div>
                <div className="career_text">
                  미국 ENDO학회 성조숙증 연구 발표
                  <br /> 성조숙증 키성장 연구 다수 발표 강의
                  <br /> 대한소아청소년과학술대회 키성장 강의
                  <br />
                  소아청소년과전문의 초음파 교육 및 강의
                  <br /> 소아청소년과 전문의 ‘심층교육’ 성장교육
                  <br /> KRS ‘행복한교실’ 소아비만
                  <br /> KBS ‘생생정보통’ 성조숙증
                  <br /> MBC ‘생방송오늘아침’ 성조숙증 방송
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="intro_img_box">
          <div className="intro_img_content">
            {[...Array(parseInt(6))].map((data, index) => {
              return (
                <div className="intro_img_cell">
                  <div className={`intro_img img${index + 1}`}></div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="intro_thesis_area">
          <div className="thesis_box">
            <div className="thesis_title">논문</div>
            <div className="thesis_text">
              Publications
              <br /> Huh K, Park MJ. A Case of Klippel-Feil Syndrome with
              Recurrent Hypoglycemia. J Korean Soc Pediatr Endocrinol. 2006
              Jun;11(1):110-115.
              <br /> Huh K, Kim HB, Kim CK, Park MJ Relationship with Eosinophil
              Cationic Protein (ECP)/Eosinophil-derived Neurotoxin (EDN) Levels
              and Growth Status among Asthmatic Children . J Korean Soc Pediatr
              Endocrinol. 2007 Dec;12(2):104-110. <br />
              Chung JY, Huh K, Kim SW, Shin BM, Han TH, Lee JI, Song MO.
              Molecular Epidemiology of Human Astrovirus Infection in
              Hospitalized Children with Acute Gastroenteritis. Korean J Pediatr
              Gastroenterol Nutr. 2006 Sep;9(2):139-146. Korean.
              <br /> Choi JG, Huh K, Kim HB, Youn YG, Kim CK. The role of TNF- а
              in Eosinophilic Inflammation of RSV Bronchiolitis. Pediatr Allergy
              Respir Dis. 2008 Jan;18(1):46-53. Huh K, Park
              MJ.Questionnaire-based analysis of growth-promoting attempts among
              children visiting a university growth clinic. Korean J Pediatr.
              2009 May;52(5):576-580.
              <br />
              Huh K, Park MJ. Preliminary analysis of metabolic syndrome
              components in Korean adolescents by using Korean national health
              and nutrition examination Survey pooling data (1998, 2001, and
              2005).Korean J Pediatr. 2008 Dec;51(12):1300-1309
              <br /> Seung Ah Lee1, Jean H. Choi1, Na Young Shin1, Myung Ah
              Rhee1, Hyun Sun Ahn1, Kyoung Huh2, Mi Jung Park2Stress,
              body-esteem, and maturity fears among girls with and precocious
              puberty. Annual Meeting of Psychology Society 2009.
              <br /> Huh K, Park MJ. Birth weight and Insulin resistance in
              obese Korean Children. Asian Pacific Pediatric Edocrine Society,
              2008 <br /> Huh K, Park MJ. Evaluation of the Growth Status of
              children born small for gestational age among VLBW. Asian Pacific
              Pediatric Edocrine Society, 2008
              <br /> Huh K, Park MJ. Urinary Di-(2-ethylhexyl) phthalate,
              Monoethylhexyl phthalate and Bisphenol-A levels in Girls with
              Precocious Puberty, 91th of Annual Meeting of Endocrine Society
              2009.
              <br /> Huh K, Park MJ. Metabolic Characteristics in Obese Girls
              with Premature Pubarche, 91th of Annual Meeting of Endocrine
              Society 2009.
              <br /> Woo MK, Kim DW, Huh K, Sim KH, Choi MJ. Study on the
              neurodevelopmental predictors for result of Bayley scales of
              infant development II in high-risk neonate. Korean J Pediatr.2009
              (in press)
              <br /> Lee JH, Lee SK, Huh K, Park MJ, Kim SH, Kim OH, Kim SY,
              Park SS, Shim GH, Chey MJ. A Case of Hypochondrogenesis Confirmed
              by Cytogenetic Analysis. 59th of Annual Meeting of Korean
              Pediatric Society 2009.
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Intro;
